module.exports = __webpack_public_path__ + "images/d99f77af09e225d8a4cab5c18cde859d.png";